import { gql } from '@apollo/client';

const query = gql`
  {
    currentUser {
      id
      displayName
      avatar
      account {
        firstName
        lastName
        email
        phoneNumber
      }
      suburb {
        id
        name
        postcode
        state
        region
        market
      }
      userRoles {
        edges {
          node {
            roleName
          }
        }
      }
    }
  }
`;

module.exports = query;
